var editor_2d = require("editor-2d");
var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");

var SymbolGeneratorToolStateMachine = function (root, editorModel, selectionModel, getDataCollection, options){
    this.root = root;
    this.getDataCollection = getDataCollection;
    this.options = options;

    editor_2d.PlacingStateMachine.call(this, root, editorModel, selectionModel, this.options.multiplePlacing);

    lib_core.GuiEvents.addEvents({
        EXPAND_CLICK:    {id: 'sgfsm_0', name: "EXPAND_CLICK", isGuiButton: true }
    });
};

lib_core.inherit(SymbolGeneratorToolStateMachine, editor_2d.PlacingStateMachine);

module.exports = SymbolGeneratorToolStateMachine;

SymbolGeneratorToolStateMachine.prototype.createElement = function (startCoord) {
    var terminalNames = this.root.data.terminalNames;    // TODO: maybe also pass this from the manifest

    var generator = new cio_datamodel.SymbolGeneratorData(startCoord, 0);
    var nameLists = ["leftNameList","bottomNameList", "rightNameList", "topNameList"];
    var size = [this.options.cLeft, this.options.cBottom, this.options.cRight, this.options.cTop];
    var name = 1;
    for (var i in nameLists){
        for (var j = 0; j < size[i]; j++){
            name = terminalNames.getProposal('', name);
            generator.collections.get(nameLists[i]).push(name);
            name++;
        }
    }
    generator.setMinBox();

    generator.addTo(this.getDataCollection());
    var interactionModel = this.editorModel.interactionModelDataMap.get(generator);
    return interactionModel;
};
